import { defineMessage } from 'services/localization';

export const messages = {
    remaining: defineMessage('remaining_amount'),
    allocatedAmountToBilledPOs: defineMessage('allocations_to_billed_pos_1'),
    allocatedAmount: defineMessage('allocations_to_not_billed_pos'),
    otherAllocatedBills: defineMessage('allocations_to_bills_on_approval'),
    allocatedAmountToNotBilledPOs: defineMessage('allocations_to_approved_bills'),
    grossAmount: defineMessage('total_gross'),
    netAmount: defineMessage('total_net'),
};
